import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import { ArrowLeftSquareFill, PlusCircleFill } from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";
import { showLoader, hideLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { showToast, hideToast } from "../../store/Toast/toast.slice";
import { Pagination } from "react-bootstrap";
import profileIcon from "../../assets/default-profile.png";
import TextArea from "../../components/TextArea/TextArea";
import { AnyNsRecord } from "dns";

const isImageUrl = (url: string) => {
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
  const extension = url.split(".").pop()?.toLowerCase();
  return extension ? imageExtensions.includes(extension) : false;
};

interface QuizItem {
  id: number;
  question: string;
  quiz_type: string;
  status: number;
  correctAnswer: string;
  correctAnswerCount: number;
  wrongAnswerCount: number;
  date: string;
  folder_name: string;
  folder_id: number;
  point: number;
}

interface UserInfo {
  name: string;
  profilePic: string;
  submittedOption: string;
}

const QuizDetails = () => {
  const navigate = useNavigate();
  // const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const id = location.state?.id;
  const [data, setData] = useState<QuizItem[]>([]);
  const [folderName, setFolderName] = useState<string>("");
  const [showModal, setShowModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [selectedImage, setSelectedImage] = useState<string>("");
  const [question, setQuestion] = useState<string>("");
  const [quizItem, setQuizItem] = useState<any>({
    id: 0,
    folder_id: 0,
    quiz_type: 1,
    question: "",
    // options: [],
    point: 0
  });


  const [answers, setAnswers] = useState<UserInfo[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useAppDispatch();

  useEffect(() => {


    fetchQuiz();
  }, [id]);

  const fetchQuiz = async () => {
    const folder_id = Number(id);
    try {
      dispatch(showLoader("Loading Data..."));
      const response = await postDetails(APIList.GET_QUIZ_BY_FOLDER_ID, {
        folder_id,
      });
      if (response.data) {
        const { folder_name, quizData } = response.data;

        if (Array.isArray(quizData)) {
          const formattedData = quizData.map((item: any) => ({
            id: item.id,
            question: item.question,
            quiz_type: item.quiz_type,
            status: item.status,
            correctAnswer: item.correct_answer,
            correctAnswerCount: item.correctAnswerCount,
            wrongAnswerCount: item.wrongAnswerCount,
            date: new Date(item.created).toLocaleString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            }),
            folder_name,
            descriptiveCount: item.descriptiveCount,
            folder_id: item.folder_id,
            point: item.point
          }));
          setFolderName(folder_name);
          setData(formattedData);
        } else {
          console.error("Unexpected response format:", response);
          setData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching quiz details:", error);
      setData([]);
    } finally {
      dispatch(hideLoader());
    }
  };

  const redirectMainList = () => {
    navigate("/quiz");
  };

  const redirectAddQuiz = () => {
    navigate("/quiz/AddQuiz");
  };

  const handleQuestionChange = (
    ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    console.log(ev.target.value);
    setQuestion(ev.target.value);
    setQuizItem((prevQuizItem: any) => ({
      ...prevQuizItem, // Keep previous properties
      question: ev.target.value, // Update only the question property
    }));
  };

  const buttons = [
    {
      label: "Back to Main List",
      theme: "danger",
      icon: <ArrowLeftSquareFill />,
      onClick: redirectMainList,
    },
    {
      label: "Add Quiz",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: redirectAddQuiz,
    },
  ];

  const handleImagePreview = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage("");
    setAnswers([]);
  };

  const handleCloseEditModal = () => {
    setEditModal(false);
    setQuestion("");
    // setAnswers([]);
  };

  const onEditClick = async () => {
    try {
      const response = await postDetails(APIList.ADD_QUIZ, quizItem);

      if (response.Status === "Failed") {
        console.log("Cannot edit quiz's question");
        return;
      } else {
        dispatch(showToast("Quiz Updated Succesfully."));
        setTimeout(() => dispatch(hideToast()), 3000);
        handleCloseEditModal();
        fetchQuiz();
      }
    } catch (e) {
      console.log(e)
    }
  }

  const editQuestionsById = async (item: QuizItem) => {
    try {
      const quizType: any = {
        "Textual Option": 1,
        "Descriptive Option": 2,
        "Image Option": 3,
        "Image Ordering Option": 4,
      }
      setQuizItem({
        id: item.id,
        folder_id: item.folder_id,
        quiz_type: quizType[item.quiz_type],
        question: item.question,
        // options: [],
        point: item.point
      });
      setQuestion(item.question)
      setEditModal(true);
    } catch (error) {
      console.error("Error editing quiz:", error);
    }
  };

  const deleteItemById = async (item: QuizItem) => {
    try {
      const response = await postDetails(APIList.DELETE_QUIZ, {
        id: item.id,
      });

      if (response.status === "Failed") {
        console.log("Cannot delete quiz");
        return;
      }

      setData((prevData) => prevData.filter((row) => row.id !== item.id));
      dispatch(showToast("Quiz Deleted Succesfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error deleting quiz:", error);
    }
  };

  const toggleStatus = async (item: QuizItem) => {
    try {
      const newStatus = item.status === 0 ? 1 : 0;
      const response = await postDetails(APIList.CHANGE_QUIZ_STATUS, {
        id: item.id,
        status: newStatus,
      });

      if (response.status === "Failed") {
        console.log("Cannot update status");
        return;
      }

      setData((prevData) =>
        prevData.map((row) =>
          row.id === item.id ? { ...row, status: newStatus } : row
        )
      );
      console.log("Status updated");
      dispatch(showToast("Status Succesfully Updated."));
      setTimeout(() => dispatch(hideToast()), 3000);
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleAnswerCount = async (
    item: QuizItem,
    type: "correct" | "wrong" | "descriptive"
  ) => {
    try {
      const response = await postDetails(APIList.GET_ALL_USER_QUIZ_DATA, {
        quiz_id: item.id,
        type: type,
      });
      if (response.statusCode === 200 && response.data) {
        const formattedUserInfo: UserInfo[] = response.data.userInfo.map(
          (user: any) => ({
            name: user.name,
            profilePic: user.profile || profileIcon,
            submittedOption: user.submittedOption || "N/A",
          })
        );

        setAnswers(formattedUserInfo);
        setCurrentPage(1);
        setShowModal(true);
      } else {
        console.error("Failed to fetch answers");
      }
    } catch (error) {
      console.error("Error fetching answers:", error);
    }
  };

  const columns: TableColumn[] = [
    {
      key: "date",
      label: "Quiz Date",
      // render: (record) =>
      //   new Date(record.date).toLocaleString("en-GB", {
      //     day: "2-digit",
      //     month: "2-digit",
      //     year: "numeric",
      //   }),
    },
    {
      key: "folder_name",
      label: "Folder Name",
      // sortable: true,
      dataType: "string",
    },
    { key: "question", label: "Question", sortable: true, dataType: "string" },
    { key: "quiz_type", label: "Quiz Type", dataType: "string" },
    {
      key: "correctAnswer",
      label: "Correct Answer",
      dataType: "string",
      render: (item: QuizItem) =>
        isImageUrl(item.correctAnswer) ? (
          <img
            src={item.correctAnswer}
            alt="Correct Answer"
            style={{ width: "100px", height: "auto" }}
          />
        ) : (
          item.correctAnswer
        ),
    },
    {
      key: "descriptiveCount",
      label: "Descriptive",
      sortable: true,
      render: (item) => {
        const count = item.descriptiveCount;

        return (
          <div
            className={`d-flex justify-content-center text-primary ${count > 0
              ? "cursor-pointer text-decoration-underline"
              : "text-muted"
              }`}
            onClick={() => count > 0 && handleAnswerCount(item, "descriptive")}
          >
            {count > 0 ? count : "N/A"}
          </div>
        );
      },
    },
    {
      key: "correctAnswerCount",
      label: "Correct Answers",
      sortable: true,
      render: (item) => {
        if (item.quiz_type === "Descriptive Option") {
          return <div className="d-flex justify-content-center text-muted">N/A</div>
        } else {
          return (
            <div
              className="text-primary cursor-pointer text-decoration-underline"
              onClick={() => handleAnswerCount(item, "correct")}
            >
              {" "}
              {item.correctAnswerCount || 0}{" "}
            </div>
          );
        }
      },
    },
    {
      key: "wrongAnswerCount",
      label: "Wrong Answers",
      sortable: true,
      render: (item) => {
        if (item.quiz_type === "Descriptive Option") {
          return <div className="d-flex justify-content-center text-muted">N/A</div>
        } else {
          return (
            <div
              className="text-primary cursor-pointer text-decoration-underline"
              onClick={() => handleAnswerCount(item, "wrong")}
            >
              {" "}
              {item.wrongAnswerCount || 0}{" "}
            </div>
          );
        }
      },
    },
  ];
  const ITEMS_PER_PAGE = 8;
  const PAGINATION_DISPLAY_LIMIT = 5;

  const totalItems = answers.length;
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const paginatedAnswers = answers.slice(startIndex, endIndex);

  const getPaginationItems = () => {
    const paginationItems = [];
    const startPage = Math.max(
      1,
      currentPage - Math.floor(PAGINATION_DISPLAY_LIMIT / 2)
    );
    const endPage = Math.min(
      totalPages,
      startPage + PAGINATION_DISPLAY_LIMIT - 1
    );

    for (let i = startPage; i <= endPage; i++) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    return paginationItems;
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };
  // const isImageUrl = (url: string) => {
  //   return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
  // };
  const isImageUrl = (url: string) => {
    const match = url.match(/\.(jpeg|jpg|gif|png)/g);
    return match && match.length === 1; // True if exactly 1 match, false otherwise
  };


  return (
    <LayoutContainer title={`Quiz - ${folderName}`}>
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Quiz - {folderName}
        </h2>
      </div>
      <PageHeader buttons={buttons} />
      <CommonTable<QuizItem>
        data={data}
        columns={columns}
        onEdit={editQuestionsById}
        onDelete={deleteItemById}
        onStatusToggle={toggleStatus}
        pagination={true}
        rowsPerPage={10}
        actions={{
          delete: true,
          edit: true,
          status: true,
        }}
      />
      <Modal show={editModal} onHide={handleCloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Question</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "300px",
            overflowY: "auto",
            padding: "1.5rem",
          }}
        >
          <div>
            <TextArea
              label="Question"
              name="question"
              value={question}
              placeholder="Enter Question"
              required={true}
              minLength={3}
              maxLength={500}
              onChangeInput={handleQuestionChange}
              showCount={true}
            // validationSchema={validate ? validationSchema : undefined}
            />
          </div>
          <button className="view-items-btn" onClick={onEditClick}>
            Update
          </button>
        </Modal.Body>
      </Modal>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Data for {folderName}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "400px",
            overflowY: "auto",
            padding: "1.5rem",
          }}
        >
          {paginatedAnswers.length > 0 ? (
            paginatedAnswers.map((user, index) => (
              <div key={index} className="d-flex align-items-center mb-3">
                <div className="me-3">
                  <img
                    src={user.profilePic || profileIcon}
                    // alt={user.name}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                    }}
                  />
                </div>
                <div>
                  <p className="mb-0">
                    <strong>{user.name}</strong>
                  </p>
                  {/* <p className="mb-0">
                    Submitted Option: {user.submittedOption || "N/A"}{" "}
                  </p> */}
                  <p className="mb-0">
                    Submitted Option:{" "}
                    {isImageUrl(user.submittedOption) ? (
                      <img
                        src={user.submittedOption}
                        // alt="Submitted Option"
                        style={{ maxWidth: "70px", maxHeight: "70px" }} // Adjust styles as needed
                      />
                    ) : (
                      <p>{user.submittedOption || "N/A"}</p>
                    )}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p>No data available for answers.</p>
          )}
        </Modal.Body>
        {totalPages > 1 && (
          <Modal.Footer>
            <Pagination>
              {currentPage !== 1 && (
                <Pagination.Prev
                  onClick={() => handlePageChange(currentPage - 1)}
                />
              )}
              {getPaginationItems()}
              {currentPage !== totalPages && (
                <Pagination.Next
                  onClick={() => handlePageChange(currentPage + 1)}
                />
              )}
            </Pagination>
          </Modal.Footer>
        )}
        {totalPages === 1 && (
          <Modal.Footer>
            <button className="btn-danger" onClick={handleCloseModal}>
              Close
            </button>
          </Modal.Footer>
        )}
      </Modal>
    </LayoutContainer>
  );
};

export default QuizDetails;
